import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { DataPersistence } from '@nrwl/nx';
import { map } from 'rxjs/operators';

import { BreedPartialState, BreedActions } from './breed.state';
import { BreedService } from '../data-access.service';

@Injectable()
export class  BreedEffects {

  loadAllEntities$ = createEffect(() => this.dataPersistence.fetch(BreedActions.LoadAll.type, {
    run: (action: any, state) => this.apiService.getAll(action.payload)
                                      .pipe(map(response => BreedActions.LoadedAll({ payload: response }))),
    onError: (action: any, error) => BreedActions.ActionError(action + error)
  }));

  createEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(BreedActions.Add.type, {
    run: (action: any, state) => this.apiService.add(action.payload)
                                      .pipe(map((response: any) => BreedActions.Added({ payload: response }))),
    onError: (action: any, error) => BreedActions.ActionError(action + error)
  }));

  updateEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(BreedActions.Update.type, {
    run: (action: any, state) => this.apiService.update(action.payload)
                                      .pipe(map((response: any) => BreedActions.Updated({ payload: response }))),
    onError: (action: any, error) => BreedActions.ActionError(action + error)
  }));

  deleteEntity$ = createEffect(() => this.dataPersistence.pessimisticUpdate(BreedActions.Delete.type, {
    run: (action: any, state) => this.apiService.delete(action.payload)
                                      .pipe(map(response => BreedActions.Deleted({ payload: response }))),
    onError: (action: any, error) => BreedActions.ActionError(action + error)
  }));

  constructor(
    private dataPersistence: DataPersistence<BreedPartialState>,
    private apiService: BreedService,
  ) {}
}
// console.log(`%cBreedEffects::ngOnInit`, 'background:yellow');
